module.exports = __webpack_public_path__ + "img/36947-112.710cc7da.jpg";